import UsersArchive from './UsersArchive'

export default UsersArchive
